import "./styles.css";
import { Box } from "@mui/material";

const ResultCard = ({ heading, headingColor, bgColor, value, image }) => {
  return (
    <Box
      className="result-card"
      style={{ borderColor: `${headingColor}`, backgroundColor: `${bgColor}` }}
    >
      <Box className="result-heading" style={{ color: `${headingColor}` }}>
        {heading}
      </Box>
      <Box className="result-value-Box">
        <img src={image} alt="" />
        <Box className="result-value">{value}</Box>
      </Box>
    </Box>
  );
};

export default ResultCard;
